import { createFileRoute } from "@tanstack/react-router";
import { useJobDetail } from "@/contexts/JobDetailContext";
import { SummaryCard } from "@/components/JobDetails/SummaryCard";

export const Route = createFileRoute("/jobs/$jobId/summary")({
  component: SummaryView,
});

function SummaryView() {
  const { summaryData, isLoading, job } = useJobDetail();

  if (isLoading) {
    return (
      <div className="pb-8">
        <div className="bg-white rounded-[1.5rem] shadow p-6">
          <p className="text-muted-foreground">Loading summary...</p>
        </div>
      </div>
    );
  }

  if (!summaryData?.summary_paragraphs?.length || !job) {
    return (
      <div className="pb-8">
        <div className="bg-white rounded-[1.5rem] shadow p-6">
          <p className="text-muted-foreground">No summary available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pb-8">
      <SummaryCard
        paragraphs={summaryData.summary_paragraphs}
        desiredWordCount={job.desiredWordCount}
      />
    </div>
  );
}
